import React, { FC } from 'react';

const mobileCameraShareStyle = {
  backgroundColor: '#3a4a66',
  borderRadius: '16px',
  color: 'white',
  'text-align': 'center',
  cursor: 'pointer',
  lineHeight: '32px',
  padding: '0 5px',
  'white-space': 'nowrap',
  minWidth: '115px',
  margin: '5px 5px',
};

interface MCSButtonProps {
  loadingMCS: boolean;
  sendSMS: () => void;
}

const MobileCameraShareButton: FC<MCSButtonProps> = (
  mobileCameraShareProps: MCSButtonProps
) => {
  const { loadingMCS, sendSMS } = mobileCameraShareProps;

  return (
    <div style={mobileCameraShareStyle} onClick={sendSMS}>
      {loadingMCS ? 'Cancel' : 'Video (SMS)'}
    </div>
  );
};

export default MobileCameraShareButton;
